import { useRoutes } from 'react-router-dom';
import TransparentHeaderRoutes from './transparent-header-routes';
import BasicHeaderRoutes from './basic-header-routes';

const Routes = () => {
	return useRoutes([TransparentHeaderRoutes, BasicHeaderRoutes]);
};

export default Routes;
